import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const HeaderFormatInvalid = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="headerFormatInvalidDesc" /></Typography>
}

export default HeaderFormatInvalid;